import { useEffect, useState } from "react";

/** Whether the app is in dark mode (the `.dark` class on <html>), kept live as the user toggles. */
export function useIsDark(): boolean {
    const [dark, setDark] = useState(() => typeof document !== "undefined" && document.documentElement.classList.contains("dark"));
    useEffect(() => {
        const root = document.documentElement;
        const sync = () => setDark(root.classList.contains("dark"));
        sync();
        const mo = new MutationObserver(sync);
        mo.observe(root, { attributes: true, attributeFilter: ["class"] });
        return () => mo.disconnect();
    }, []);
    return dark;
}
